import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { OrganizationFormData } from "@/domain/organization";

const initialFormData: OrganizationFormData = {
  name: "",
  advisoryNumber: "",
  nif: "",
  email: "",
  phone: "",
  website: "",
  fiscal_id: "",
  tax_advisor_id: "",
  address: {
    street: "",
    city: "",
    postalCode: "",
    province: "",
    country: "",
  },
  colorPalette: "zinc",
  logo: null,
  logo_signed_url: undefined,
};

interface OrganizationStoreState {
  selectedOrganizationUuid: string | null;
  organizationData: OrganizationFormData;

  setSelectedOrganizationUuid: (uuid: string | null) => void;
  setOrganizationData: (data: Partial<OrganizationFormData>) => void;
  resetFormData: () => void;
  reset: () => void;
}

export const useOrganizationStore = create<OrganizationStoreState>()(
  devtools(
    (set) => ({
      selectedOrganizationUuid: null,
      organizationData: { ...initialFormData },

      setSelectedOrganizationUuid: (uuid) => set({ selectedOrganizationUuid: uuid }),

      setOrganizationData: (data) =>
        set((state) => ({
          organizationData: { ...state.organizationData, ...data },
        })),

      resetFormData: () => set({ organizationData: { ...initialFormData } }),

      reset: () =>
        set({
          selectedOrganizationUuid: null,
          organizationData: { ...initialFormData },
        }),
    }),
    { name: "OrganizationStore" },
  ),
);
